/* Фикс для стрелок свайпера */

function getScopedNavigation(container, fallbackParent = null) {
  const scope = fallbackParent || container;
  return {
    nextEl: scope ? scope.querySelector('.swiper-arrow-next') : null,
    prevEl: scope ? scope.querySelector('.swiper-arrow-prev') : null,
  };
}

/* Шапка */

function initHeaderScroll() {
  const header = document.querySelector('header');
  if (!header) return;

  document.addEventListener('scroll', function () {
    if (window.scrollY > 100) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
}

/* Слайдер - cпециальные предложения в шапке */

function initSpecialsSwiper() {
  const specialsSliderEl = document.querySelector('.swiper-specials');
  if (!specialsSliderEl || typeof Swiper === 'undefined') return;

  new Swiper(specialsSliderEl, {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 800,
    autoHeight: false,
    navigation: {
      nextEl: specialsSliderEl
        .closest('.specials')
        .querySelector('.swiper-arrow-next'),
      prevEl: specialsSliderEl
        .closest('.specials')
        .querySelector('.swiper-arrow-prev'),
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 4
      },
    },
  });
}


/* Hero block анимация контейнера */

function initHeroPictureAnimation() {
    const picture = document.querySelector('.hero__image');
    if (!picture) return;

    requestAnimationFrame(() => {
        picture.classList.add('is-visible');
    });
}

/* Популярные услуги */

function initPopularServicesSwiper() {
  const sliderEl = document.querySelector('.popular-services__slider');

  if (!sliderEl || typeof Swiper === 'undefined') {
    return;
  }

  const section = sliderEl.closest('.popular-services');
  const wrapper = sliderEl.querySelector('.swiper-wrapper');
  const mediaQuery = window.matchMedia('(max-width: 575px)');

  let swiper = null;

  function enableSwiper() {
    if (swiper) {
      return;
    }

    wrapper.classList.remove('grid-4-column');

    swiper = new Swiper(sliderEl, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 800,
      navigation: {
        nextEl: section.querySelector('.swiper-arrow-next'),
        prevEl: section.querySelector('.swiper-arrow-prev'),
      },
    });
  }

  function disableSwiper() {
    if (!swiper) {
      wrapper.classList.add('grid-4-column');
      return;
    }

    swiper.destroy(true, true);
    swiper = null;

    wrapper.classList.add('grid-4-column');
  }

  function handleBreakpoint(event) {
    if (event.matches) {
      enableSwiper();
    } else {
      disableSwiper();
    }
  }

  handleBreakpoint(mediaQuery);
  mediaQuery.addEventListener('change', handleBreakpoint);
}


/* Популярные направления */

function initPopularServicesAnimation() {
  const section = document.querySelector('.popular-services');
  const items = section?.querySelectorAll('.popular-services__item');

  if (!section || !items.length) {
    return;
  }

  items.forEach((item) => {
    item.style.opacity = '0';
    item.style.transform = 'translateY(10%)';
    item.style.transition = 'transform 1s ease, opacity 1s ease';
  });

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        return;
      }

      items.forEach((item, index) => {
        setTimeout(() => {
          const handleTransitionEnd = (event) => {
            if (
              event.target !== item ||
              event.propertyName !== 'transform'
            ) {
              return;
            }

            item.style.removeProperty('opacity');
            item.style.removeProperty('transform');
            item.style.removeProperty('transition');

            item.removeEventListener(
              'transitionend',
              handleTransitionEnd
            );
          };

          item.addEventListener(
            'transitionend',
            handleTransitionEnd
          );

          item.style.opacity = '1';
          item.style.transform = 'translateY(0)';
        }, (index + 1) * 200);
      });

      observer.unobserve(section);
    },
    {
      threshold: 0.1,
    }
  );

  observer.observe(section);
}

/* Блок преимущества */

function initFeaturesSwiper() {
  const sliderEl = document.querySelector('.features__slider');

  if (!sliderEl || typeof Swiper === 'undefined') {
    return null;
  }

  const section = sliderEl.closest('.features');

  const featuresSwiper = new Swiper(sliderEl, {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 800,
    autoHeight: false,
    navigation: {
      nextEl: section?.querySelector('.swiper-arrow-next'),
      prevEl: section?.querySelector('.swiper-arrow-prev'),
    },
    breakpoints: {
      576: {
        slidesPerView: 1.4,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 2.4,
        spaceBetween: 24,
      },
      992: {
        slidesPerView: 2.8,
        spaceBetween: 24,
      },
      1200: {
        slidesPerView: 3.4,
        spaceBetween: 32,
      },
    },
  });

  return featuresSwiper;
}


/* Блок - с нами работают */

function initCompaniesSwiper() {
  const sliderEl = document.querySelector('.companies__slider');

  if (!sliderEl || typeof Swiper === 'undefined') {
    return null;
  }

  const section = sliderEl.closest('.companies');

  if (!section) {
    return null;
  }

  const slidesCount = sliderEl.querySelectorAll('.swiper-slide').length;
  const canLoop = slidesCount > 4;

  const companiesSwiper = new Swiper(sliderEl, {
    loop: canLoop,
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 800,
    watchOverflow: true,
    autoplay: slidesCount > 1
      ? {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }
      : false,
    navigation: {
      nextEl: section.querySelector('.swiper-arrow-next'),
      prevEl: section.querySelector('.swiper-arrow-prev'),
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
  });

  return companiesSwiper;
}


/* FAQ */

function initFaq() {
    const faqBlocks = document.querySelectorAll('.faq__box');

    if (!faqBlocks.length) {
        return;
    }

    faqBlocks.forEach((faqBlock) => {
        const triggers = faqBlock.querySelectorAll('.faq__trigger');

        triggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                const answerId = trigger.getAttribute('aria-controls');
                const answer = document.getElementById(answerId);

                if (!answer) {
                    return;
                }

                const isExpanded =
                    trigger.getAttribute('aria-expanded') === 'true';

                triggers.forEach((otherTrigger) => {
                    if (otherTrigger === trigger) {
                        return;
                    }

                    const otherAnswerId =
                        otherTrigger.getAttribute('aria-controls');

                    const otherAnswer =
                        document.getElementById(otherAnswerId);

                    if (
                        otherAnswer &&
                        otherTrigger.getAttribute('aria-expanded') === 'true'
                    ) {
                        closeFaqItem(otherTrigger, otherAnswer);
                    }
                });

                if (isExpanded) {
                    closeFaqItem(trigger, answer);
                } else {
                    openFaqItem(trigger, answer);
                }
            });
        });
    });
}

function openFaqItem(trigger, answer) {
    trigger.setAttribute('aria-expanded', 'true');

    answer.hidden = false;
    answer.style.height = '0px';

    requestAnimationFrame(() => {
        answer.style.height = `${answer.scrollHeight}px`;
    });

    answer.addEventListener(
        'transitionend',
        () => {
            if (trigger.getAttribute('aria-expanded') === 'true') {
                answer.style.height = 'auto';
            }
        },
        { once: true }
    );
}

function closeFaqItem(trigger, answer) {
    trigger.setAttribute('aria-expanded', 'false');

    answer.style.height = `${answer.scrollHeight}px`;

    requestAnimationFrame(() => {
        answer.style.height = '0px';
    });

    answer.addEventListener(
        'transitionend',
        () => {
            if (trigger.getAttribute('aria-expanded') === 'false') {
                answer.hidden = true;
                answer.style.height = '';
            }
        },
        { once: true }
    );
}

/* Новости */

function initNewsTabs() {
    document.querySelectorAll('[data-news-tabs]').forEach(tabs => {
        const buttons = [...tabs.querySelectorAll('[data-news-tab]')];
        const panels = [...tabs.querySelectorAll('[data-news-panel]')];

        const activate = id => {
            buttons.forEach(button => {
                const active = button.dataset.newsTab === id;
                button.classList.toggle('is-active', active);
                button.setAttribute('aria-selected', String(active));
                button.tabIndex = active ? 0 : -1;
            });

            panels.forEach(panel => {
                const active = panel.dataset.newsPanel === id;
                panel.classList.toggle('is-active', active);
                panel.hidden = !active;
            });
        };

        tabs.addEventListener('click', event => {
            const button = event.target.closest('[data-news-tab]');
            if (!button || !tabs.contains(button)) return;
            activate(button.dataset.newsTab);
        });

        tabs.addEventListener('keydown', event => {
            const currentIndex = buttons.indexOf(document.activeElement);
            if (currentIndex < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

            event.preventDefault();
            let nextIndex = currentIndex;
            if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % buttons.length;
            if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = buttons.length - 1;

            buttons[nextIndex].focus();
            activate(buttons[nextIndex].dataset.newsTab);
        });
    });
}

/* Табы новостей */

document.querySelectorAll('[data-post-tabs]').forEach((tabs) => {
  const buttons = Array.from(
    tabs.querySelectorAll('[data-tab-button]')
  );

  const panels = Array.from(
    tabs.querySelectorAll('[data-tab-panel]')
  );

  const activateTab = (activeButton) => {
    const activeTab = activeButton.dataset.tabButton;

    buttons.forEach((button) => {
      const isActive = button === activeButton;

      button.classList.toggle('is-active', isActive);
      button.setAttribute(
        'aria-selected',
        String(isActive)
      );
      button.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach((panel) => {
      const isActive =
        panel.dataset.tabPanel === activeTab;

      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  };

  buttons.forEach((button, index) => {
    button.addEventListener('click', () => {
      activateTab(button);
    });

    button.addEventListener('keydown', (event) => {
      if (
        event.key !== 'ArrowLeft' &&
        event.key !== 'ArrowRight'
      ) {
        return;
      }

      event.preventDefault();

      const direction =
        event.key === 'ArrowRight' ? 1 : -1;

      const nextIndex =
        (index + direction + buttons.length) %
        buttons.length;

      buttons[nextIndex].focus();
      activateTab(buttons[nextIndex]);
    });
  });
});

/* Адаптивные таблицы */

function initResponsiveTables() {
    document.querySelectorAll('.article__content table').forEach((table) => {
        if (table.parentElement.classList.contains('table-responsive')) {
            return;
        }

        const wrapper = document.createElement('div');

        wrapper.className = 'table-responsive';

        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
}

/* Инициализация */

document.addEventListener('DOMContentLoaded', function () {
  initHeaderScroll();
  initSpecialsSwiper();
  initHeroPictureAnimation();
  initPopularServicesSwiper();
  initFeaturesSwiper();
  initPopularServicesAnimation();
  initCompaniesSwiper();
  initFaq();
  initNewsTabs();
  initResponsiveTables();
});